export const parseInputNumber = (val: string) => (val === "" ? null : +val);
